import { useState, useRef, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useBranding } from '../../contexts/BrandingContext';
import { minhasEmpresas, trocarEmpresa } from '../../api/auth';

/* ── Ícones ────────────────────────────────────────────────── */
const ICON = {
  dashboard: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>,
  clientes:  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  usuarios:  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="4"/><path d="M20 21a8 8 0 1 0-16 0"/></svg>,
  tipos:     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 6h16M4 10h16M4 14h10"/></svg>,
  cores:     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="13.5" cy="6.5" r="2.5"/><circle cx="19" cy="13" r="2.5"/><circle cx="6" cy="12" r="2.5"/><circle cx="9" cy="19" r="2.5"/></svg>,
  tamanhos:  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 6H3M21 12H3M21 18H8"/><path d="M3 18v-4M3 12V8"/></svg>,
  areas:     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-6h6v6"/></svg>,
  modelos:   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 3v18M15 3v18M3 9h18M3 15h18"/></svg>,
  estoque:   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>,
  demandas:  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
  pedidos:   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 12h6M9 16h4"/></svg>,
  catalogo:  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>,
  carrinho:  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>,
  empresas:  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 21h18"/><path d="M5 21V7l6-4 6 4v14"/><path d="M9 9h.01M9 13h.01M15 9h.01M15 13h.01"/><path d="M10 21v-4h4v4"/></svg>,
  logs:      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M9 13h6M9 17h6"/></svg>,
  auditoria: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 3v18h18"/><path d="M7 14l4-4 3 3 5-6"/></svg>,
  financeiro: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v10M15 9.5c0-1.4-1.3-2.5-3-2.5s-3 1-3 2.3c0 3 6 1.5 6 4.5 0 1.4-1.3 2.5-3 2.5s-3-1.1-3-2.5"/></svg>,
  cadastros: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="4" y="3" width="16" height="18" rx="2"/><path d="M9 3v3h6V3M8 11h8M8 15h8"/></svg>,
  logout:    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  editUser:  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  menu:      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>,
  chevronDown: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>,
  chevronLeft: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>,
  chevronRight: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>,
  search:      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  check:       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>,
  globe:       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
};

/* Iniciais (até 2 letras) do nome de uma empresa, para o avatar do seletor */
function iniciaisEmpresa(nome) {
  const partes = (nome || '').trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return '?';
  if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase();
  return (partes[0][0] + partes[1][0]).toUpperCase();
}

/* Cor determinística (hash do id) para o avatar — cada empresa sem logo próprio no
 * seletor ganha uma cor estável, em vez de todas caírem no mesmo cinza genérico. */
function corEmpresa(id) {
  let hash = 0;
  for (let i = 0; i < (id || '').length; i++) hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  const hue = hash % 360;
  return `hsl(${hue}, 42%, 38%)`;
}

// Seções do menu de operador/gestor/admin. `perfis` restringe um item a quem de
// fato tem a rota liberada (ver PrivateRoute/backend) — sem isso, ex.: operador via
// um link "Usuários" que sempre voltava pro dashboard ao clicar (rota é gestor/admin).
const NAV_SECTIONS_STAFF = [
  {
    titulo: null,
    itens: [
      { to: '/dashboard', label: 'Dashboard', icon: 'dashboard' },
    ],
  },
  {
    titulo: 'Cadastros',
    itens: [
      { to: '/clientes',       label: 'Clientes', icon: 'clientes' },
      { to: '/areas',          label: 'Áreas',     icon: 'areas' },
      { to: '/usuarios',       label: 'Usuários',  icon: 'usuarios', perfis: ['gestor', 'admin'] },
      { to: '/tipos-uniforme', label: 'Tipos',     icon: 'tipos' },
      { to: '/cores-uniforme', label: 'Cores',     icon: 'cores' },
      { to: '/tamanhos-uniforme', label: 'Tamanhos', icon: 'tamanhos' },
      { to: '/modelos',        label: 'Modelos',   icon: 'modelos' },
    ],
  },
  {
    titulo: 'Operação',
    itens: [
      { to: '/catalogo-op', label: 'Catálogo', icon: 'catalogo' },
      { to: '/estoque',     label: 'Estoque',   icon: 'estoque' },
      { to: '/demandas',    label: 'Demandas',  icon: 'demandas' },
      { to: '/pedidos',     label: 'Pedidos',   icon: 'pedidos' },
    ],
  },
  {
    titulo: 'Gestão',
    itens: [
      { to: '/empresas', label: 'Empresas', icon: 'empresas', perfis: ['admin'] },
      { to: '/painel-financeiro', label: 'Painel Financeiro', icon: 'financeiro', perfis: ['gestor', 'admin'] },
      { to: '/painel-cadastros', label: 'Painel de Cadastros', icon: 'cadastros', perfis: ['gestor', 'admin'] },
      { to: '/painel-auditoria', label: 'Painel de Auditoria', icon: 'auditoria', perfis: ['admin'] },
      { to: '/logs', label: 'Logs', icon: 'logs', perfis: ['admin'] },
    ],
  },
];

const NAV_CLIENTE = [
  { to: '/catalogo',       label: 'Catálogo',     icon: 'catalogo'  },
  { to: '/carrinho',       label: 'Carrinho',     icon: 'carrinho'  },
  { to: '/meus-pedidos',   label: 'Meus Pedidos', icon: 'pedidos'   },
];

const PERFIL_LABEL = { admin: 'Administrador', operador: 'Operador', gestor: 'Gestor', cliente: 'Cliente' };

export default function AppLayout({ children }) {
  const { user, logout, loginSuccess } = useAuth();
  const { branding, loadAtiva } = useBranding();
  const navigate = useNavigate();
  const [collapsed, setCollapsed]       = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [empresasColab, setEmpresasColab] = useState([]);
  const [buscaEmpresa, setBuscaEmpresa] = useState('');
  const dropdownRef = useRef(null);

  // Gestor é o admin de UMA empresa — mesma navegação de operador (que já cobre
  // tudo), só que com mais poder em usuários (ver PrivateRoute/backend). Cada
  // seção só aparece se sobrar pelo menos 1 item depois do filtro por perfil.
  const navSections = user?.perfil === 'cliente'
    ? [{ titulo: null, itens: NAV_CLIENTE }]
    : NAV_SECTIONS_STAFF
        .map(sec => ({ ...sec, itens: sec.itens.filter(i => !i.perfis || i.perfis.includes(user?.perfil)) }))
        .filter(sec => sec.itens.length > 0);

  // Garante a marca correta após um refresh de página (a sessão é restaurada via
  // GET /auth/me, mas a paleta de cores/nome da empresa ativa precisa ser buscada
  // separadamente — ver BrandingContext.loadAtiva).
  useEffect(() => { loadAtiva(); }, [loadAtiva]);

  // Seletor de "trocar empresa": gestor/cliente podem estar vinculados a mais de uma
  // (colab); admin não tem empresa fixa nenhuma (eoa sempre null até escolher uma) —
  // sem isto, admin não tinha como entrar no contexto de empresa nenhuma e qualquer
  // cadastro operacional (cores, tipos, modelos...) falhava com "selecione uma empresa".
  useEffect(() => {
    if (['gestor', 'cliente', 'admin'].includes(user?.perfil)) {
      minhasEmpresas().then(r => setEmpresasColab(r.data)).catch(() => setEmpresasColab([]));
    }
  }, [user?.perfil]);

  // Admin sempre vê a seção — mesmo com 0/1 empresa cadastrada — porque é o único jeito
  // de voltar ao modo global (empresa_ativa_id=null) depois de entrar no contexto de uma.
  const precisaEscolherEmpresa = user?.perfil === 'admin' ? true : empresasColab.length > 1;

  const empresasFiltradas = empresasColab.filter(e =>
    e.nome.toLowerCase().includes(buscaEmpresa.trim().toLowerCase())
  );

  const handleTrocarEmpresa = async (idEmpresa) => {
    setDropdownOpen(false);
    try {
      const { data } = await trocarEmpresa(idEmpresa);
      loginSuccess(data);
      window.location.reload(); // garante que todas as listas já abertas recarreguem com a nova empresa ativa
    } catch (err) {
      alert(err.response?.data?.detail || 'Erro ao trocar de empresa.');
    }
  };

  /* Fecha dropdown ao clicar fora */
  useEffect(() => {
    const handle = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target))
        setDropdownOpen(false);
    };
    document.addEventListener('mousedown', handle);
    return () => document.removeEventListener('mousedown', handle);
  }, []);

  const handleLogout = async () => {
    setDropdownOpen(false);
    await logout();
    navigate('/login');
  };

  /* Iniciais do nome */
  const initials = user?.nome
    ? user.nome.trim().split(/\s+/).slice(0, 2).map(n => n[0]).join('').toUpperCase()
    : (user?.email?.[0] || '?').toUpperCase();

  const perfilLabel = PERFIL_LABEL[user?.perfil] || user?.perfil;

  const nomeEmpresa = branding?.nome || 'Portal de Pedidos';
  const inicialEmpresa = nomeEmpresa.trim().slice(0, 3).toUpperCase();

  return (
    <div className={`cjc-layout${collapsed ? ' sidebar-collapsed' : ''}`}>

      {/* ── Sidebar ── */}
      <aside className={`cjc-sidebar${collapsed ? ' collapsed' : ''}`}>

        {/* Brand */}
        <div className="cjc-sidebar-brand">
          <div className="cjc-brand-mark">
            {branding?.logo_url ? (
              <img src={branding.logo_url} alt={nomeEmpresa} style={{ width: 32, height: 32, objectFit: 'contain' }} />
            ) : (
              <svg viewBox="0 0 32 32" fill="none">
                <rect width="32" height="32" rx="4" fill="var(--cjc-accent)" />
                <text x="50%" y="54%" dominantBaseline="middle" textAnchor="middle"
                  fill="white" fontSize="11" fontWeight="800" fontFamily="system-ui">{inicialEmpresa}</text>
              </svg>
            )}
          </div>
          <span className="cjc-brand-text">{nomeEmpresa}</span>
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
          {navSections.map((sec, i) => (
            <ul key={sec.titulo || `sec-${i}`} className="cjc-nav">
              {sec.titulo && <li className="cjc-nav-section-label">{sec.titulo}</li>}
              {sec.itens.map(item => (
                <li key={item.to} className="cjc-nav-item">
                  <NavLink
                    to={item.to}
                    title={collapsed ? item.label : undefined}
                    className={({ isActive }) => `cjc-nav-link${isActive ? ' active' : ''}`}
                  >
                    <span className="cjc-nav-icon">{ICON[item.icon]}</span>
                    <span className="cjc-nav-label">{item.label}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          ))}
        </nav>

        {/* Toggle */}
        <button
          className="cjc-sidebar-toggle"
          onClick={() => setCollapsed(c => !c)}
          title={collapsed ? 'Expandir menu' : 'Recolher menu'}
        >
          <span className="cjc-toggle-icon">
            {collapsed ? ICON.chevronRight : ICON.chevronLeft}
          </span>
          <span className="cjc-toggle-label">Recolher</span>
        </button>
      </aside>

      {/* ── Main ── */}
      <main className="cjc-main">

        {/* Topbar */}
        <header className="cjc-topbar">
          {/* Esquerda — toggle mobile / título */}
          <div className="cjc-topbar-left">
            <button className="cjc-topbar-toggle" onClick={() => setCollapsed(c => !c)} title="Menu">
              {ICON.menu}
            </button>
            <span className="cjc-topbar-brand">Portal de Pedidos</span>
          </div>

          {/* Direita — usuário */}
          <div className="cjc-topbar-right" ref={dropdownRef}>
            <button
              className={`cjc-user-btn${dropdownOpen ? ' open' : ''}`}
              onClick={() => { setDropdownOpen(o => !o); setBuscaEmpresa(''); }}
              aria-haspopup="true"
              aria-expanded={dropdownOpen}
            >
              <div className="cjc-user-avatar">{initials}</div>
              <div className="cjc-user-info">
                <span className="cjc-user-name">{user?.nome || user?.email}</span>
                <span className="cjc-user-role">{perfilLabel}</span>
              </div>
              <span className={`cjc-user-chevron${dropdownOpen ? ' open' : ''}`}>
                {ICON.chevronDown}
              </span>
            </button>

            {dropdownOpen && (
              <div className="cjc-user-dropdown">
                <div className="cjc-dropdown-header">
                  <div className="cjc-dropdown-name">{user?.nome || user?.email}</div>
                  <div className="cjc-dropdown-role">{perfilLabel}</div>
                </div>
                <div className="cjc-dropdown-divider" />
                {precisaEscolherEmpresa && (
                  <>
                    <div className="cjc-empresa-label">
                      {user?.perfil === 'admin' ? 'Empresa ativa' : 'Trocar empresa'}
                    </div>

                    {user?.perfil === 'admin' && (
                      <button className="cjc-empresa-item" onClick={() => handleTrocarEmpresa(null)}>
                        <span className="cjc-empresa-avatar cjc-empresa-avatar--global">{ICON.globe}</span>
                        <span className="cjc-empresa-nome">Global (todas as empresas)</span>
                        {!user?.empresa_ativa_id && <span className="cjc-empresa-check">{ICON.check}</span>}
                      </button>
                    )}

                    {empresasColab.length > 5 && (
                      <div className="cjc-empresa-search">
                        <span className="cjc-empresa-search-icon">{ICON.search}</span>
                        <input
                          autoFocus
                          value={buscaEmpresa}
                          onChange={e => setBuscaEmpresa(e.target.value)}
                          placeholder="Buscar empresa..."
                        />
                      </div>
                    )}

                    <div className="cjc-empresa-list">
                      {empresasFiltradas.length === 0 ? (
                        <div className="cjc-empresa-vazio">Nenhuma empresa encontrada.</div>
                      ) : (
                        empresasFiltradas.map(emp => {
                          const ativa = emp.id_empresa_operadora === user?.empresa_ativa_id;
                          return (
                            <button key={emp.id_empresa_operadora} className="cjc-empresa-item"
                              onClick={() => handleTrocarEmpresa(emp.id_empresa_operadora)}>
                              <span className="cjc-empresa-avatar" style={{ background: corEmpresa(emp.id_empresa_operadora) }}>
                                {iniciaisEmpresa(emp.nome)}
                              </span>
                              <span className="cjc-empresa-nome">{emp.nome}</span>
                              {ativa && <span className="cjc-empresa-check">{ICON.check}</span>}
                            </button>
                          );
                        })
                      )}
                    </div>
                    <div className="cjc-dropdown-divider" />
                  </>
                )}
                <button className="cjc-dropdown-item" onClick={() => { setDropdownOpen(false); navigate('/perfil'); }}>
                  <span className="cjc-dropdown-item-icon">{ICON.editUser}</span>
                  Editar Perfil
                </button>
                <button className="cjc-dropdown-item cjc-dropdown-item--danger" onClick={handleLogout}>
                  <span className="cjc-dropdown-item-icon">{ICON.logout}</span>
                  Sair
                </button>
              </div>
            )}
          </div>
        </header>

        {/* Conteúdo */}
        <div className="cjc-content">
          {children}
        </div>
      </main>

    </div>
  );
}
